const LOAD_STATUS = {
  INIT: 'init',
  ING: 'ing',
  FAILED: 'failed',
  SUCCESS: 'success',
  FIRST: 'first',
  COMPLETED: 'completed',
};

export default LOAD_STATUS;
